export type MobileAppVariant = 'admin' | 'user'

interface BannerContent {
  title: string
  description: string
}

interface ModalStepContent {
  title: string
  description: string
}

export interface MobileAppContent {
  banner: BannerContent
  modalTitle: string
  generateCodeCta: string
  steps: ModalStepContent[]
}

export const MOBILE_APP_CONTENT: Record<MobileAppVariant, MobileAppContent> = {
  user: {
    banner: {
      title: 'Acesse pelo app',
      description: 'Tenha uma experiência mais rápida e completa no seu celular',
    },
    modalTitle: 'Siga os passos abaixo',
    generateCodeCta: 'Gerar código',
    steps: [
      {
        title: 'Baixe o aplicativo',
        description:
          'Baixe o app da Start Capital no seu celular através das lojas de aplicativos, disponível para Apple e Android',
      },
      {
        title: 'Gere seu código de acesso',
        description: 'Clique no botão abaixo para gerar seu código de acesso',
      },
      {
        title: 'Acesse pelo app',
        description:
          'No app, informe seu email e, em seguida, o código gerado acima',
      },
    ],
  },
  admin: {
    banner: {
      title: 'Sua operação também no celular!',
      description:
        'Baixe o aplicativo Parceiro Start Capital e gerencie a sua operação de onde tiver.',
    },
    modalTitle: 'Siga os passos abaixo',
    generateCodeCta: 'Gerar código',
    steps: [
      {
        title: 'Baixe o app',
        description:
          'Baixe o Parceiro Start Capital no seu celular. Disponível para iPhone e Android, na App Store e no Google Play.',
      },
      {
        title: 'Gere seu código de acesso',
        description:
          'Toque em Gerar código abaixo. Você vai usá-lo para entrar no app.',
      },
      {
        title: 'Entre no app',
        description:
          'Abra o Parceiro Start Capital, informe seu e-mail e digite o código gerado aqui.',
      },
    ],
  },
}
